import { programmeYears } from '../../core/global.js';

$(function () {
    $('.delete-permission-btn').on('click', function () {
        var $button      = $(this);
        var $modal       = $('#delete-permission-modal');
        var permissionId = $button.data('id');
        var userFullName = $button.data('user-full-name');

        $modal.find('input[name="id"]').val(permissionId).trigger('change');
        $modal.find('.permitted-user-name-text').text(userFullName);
    });

    $('.new-permission-btn').on('click', function () {
        var $modal = $('#new-permission-modal');

        // Reset entire form
        $modal.find('form')[0].reset();

        // Clear the user dropdown
        $('#user-id').val('').trigger('change');

        // Clear the year dropdowns
        for (const yearIndex of programmeYears) {
            $('select[name="year_' + yearIndex + '"]').val('').trigger('change');
        }

        // Reset title text
        $modal.find('.modal-title-text').text('Grant Access Permissions');

        // Clear hidden ID
        $('#permission-id').val('');
    });

    $('.edit-permission-btn').on('click', function () {
        var $button      = $(this);
        var permissionId = $button.data('id');
        var userId       = $button.data('user-id');

        // Set the permission ID
        $('#permission-id').val(permissionId);

        // Pre-fill the user dropdown
        $('#user-id').val(userId).trigger('change');

        // Pre-fill the year dropdowns
        for (const yearIndex of programmeYears) {
            const yearValue = $button.data('year' + yearIndex);
            $('select[name="year_' + yearIndex + '"]').val(yearValue).trigger('change');
        }
    });

    $('#new-permission-modal').on('show.bs.modal', function (e) {
        var $modal  = $(this);
        var $button = $(e.relatedTarget);

        if ($button.hasClass('edit-permission-btn')) {
            var text = 'Edit Access Permissions';
            $modal.find('.modal-title-text').text(text);
        }
    });
});
